var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9289 0.507812C14.9526 0.559896 14.9704 0.611979 14.9822 0.664063C14.9941 0.716146 15 0.77474 15 0.839844C15 0.94401 14.9822 1.04818 14.9467 1.15234C14.9111 1.24349 14.8578 1.32812 14.7867 1.40625L9.01066 8.18359V14.1797C9.01066 14.401 8.93365 14.5964 8.77962 14.7656C8.63744 14.9219 8.46564 15 8.26422 15C8.15758 15 8.0628 14.987 7.97986 14.9609C7.89692 14.9219 7.8199 14.8698 7.74881 14.8047L6.23815 13.3203C6.15521 13.2422 6.09005 13.151 6.04265 13.0469C6.00711 12.9297 5.98934 12.8125 5.98934 12.6953V8.18359L0.21327 1.40625C0.14218 1.32812 0.0888626 1.24349 0.0533175 1.15234C0.0177725 1.04818 0 0.94401 0 0.839844C0 0.605469 0.0710901 0.410156 0.21327 0.253906C0.367299 0.0846354 0.550948 0 0.764218 0H14.2358C14.3898 0 14.5261 0.0520833 14.6446 0.15625C14.7749 0.247396 14.8697 0.364583 14.9289 0.507812Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon2.11ba2ce5cb04a333e30dabd0fffe985f.svg";
export { ForwardRef as ReactComponent };